const USER_TIER_TYPES = {
  CLUB: 'CLUB',
};
const EXPIRED = 'expired';

export const isSelectMember = (userData) => userData?.subscriptionType === 'ANNUAL';

export const getUserRole = (userData) => (isSelectMember(userData) ? 'select' : 'customer');

export const getSubscriptionState = (userData) =>
  userData?.subscriptionState?.toLowerCase() ?? EXPIRED;

export const isClubMember = (userData) => userData?.tier === USER_TIER_TYPES.CLUB;
